import type React from "react";
import { Grid, styled, type GridProps } from "@mui/material";

interface ModalHeaderContainerProps extends GridProps {
	divider?: boolean;
}

export const ModalHeaderContainer: React.FC<ModalHeaderContainerProps> = styled(
	(props) => (
		<Grid
			container
			display="grid"
			gridTemplateColumns="auto min-content"
			gridTemplateRows="min-content min-content"
			gridTemplateAreas={`"title close"
							"subtitle ."`}
			columnGap={2}
			alignItems="center"
			{...props}
		/>
	),
	{ shouldForwardProp: (prop) => prop !== "divider" },
)<ModalHeaderContainerProps>(({ divider, theme }) => ({
	padding: theme.spacing(3),
	paddingBottom: divider ? theme.spacing(3) : 0,
	borderBottom: divider ? `1px solid ${theme.palette.divider}` : "none",
}));
